import type Item from 'owa-service/lib/contract/Item';

export interface USQStore {
    // ESQ storage for the account
    emailStorage: StorageData;

    // MSQ storage for the account
    microsoftStorage: StorageData;

    // List of selected items from manageMail view
    selectedItems: Item[];
}

export interface StorageData {
    // Bytes of total storage available
    totalSpace: number;

    // Bytes of storage used
    usedSpace: number;

    // Storage state for ESQ and MSQ
    state: ClientStorageState;

    // Fetch status
    storageDetailsFetchStatus: StorageDetailsFetchStatus;

    // Enforcement state
    enforcementState?: string;
}

export const enum ClientStorageState {
    // When EmailStorage usage is < 90% and
    // MicrosoftStorage state is 'normal'/undefined in response
    Normal,

    // When 90% <= EmailStorage usage is < 95% and
    // MicrosoftStorage state is 'nearing' in response
    Nearing,

    // When 95% <= EmailStorage usage is < 100% and
    // MicrosoftStorage state is 'critical' in response
    Critical,

    // When EmailStorage usage is > 100% and
    // MicrosoftStorage state is 'full'/'overLimit'/'overQuota' in response
    Exceeded,
}

export enum StorageDetailsFetchStatus {
    NONE,
    SUCCESS,
    FAILURE,
}
